<template>
    <div>
        <header class="site-header bg-white border-b-2 border-grey-light pin-t w-full z-50">
            <div class="flex items-center justify-between p-1 md:p-3">
                <router-link to="/" class="logo-brand block relative md:w-72 mr-3"
                    title="Home Page"
                    aria-label="Click here to go to the home page">
                    <SvgOreillyLogoLg class="w-full block h-full absolute hidden md:block"
                        role="img"
                        alt="The Certified Auto Repair Centers Logo" />
                    <SvgOreillyLogoMd class="w-full block h-full md:hidden"
                        role="img"
                        alt="The Certified Auto Repair Centers Logo" />
                </router-link>
                <button class="text-black text-xs md:text-md mr-6 hover:text-green underline" @click="$refs.modal.open()">
                    Use of O'Reilly Shop Referral Disclaimer
                </button>
                <a href="https://www.oreillyauto.com"
                    class="text-black no-underline text-sm md:text-md font-bold pr-3 hover:text-green">
                    CONTINUE SHOPPING
                </a>
            </div>
        </header>
        <Modal ref="modal"
            :overlayClose="true"
            :overflow="false"
            :ariaLabelledBy="'modalTitle'"
            :ariaDescribedBy="'modalContent'">
            <div slot="title">
                <h2 id="modalTitle" class="text-lg md:text-xl">Use of O'Reilly Shop Referral Disclaimer</h2>
            </div>
            <div slot="content">
                <div id="modalContent" class="max-w-md mb-6">
                    <p class="mt-3 mb-6 mx-6 sm:mx-12 md:mx-16 text-left text-2xs sm:text-xs">
                        O'Reilly Automotive Stores, Inc., O'Reilly Auto Parts ("O'Reilly") provides a
                        listing of auto repair shops ("Shops") for informational purposes only. Information
                        about a Shop in the listing is based upon information provided by a representative of
                        the Shop to O'Reilly. As such, O'Reilly has not verified and does not warrant the
                        accuracy of the information in the listing. O'Reilly also has not verified nor does
                        it warranty the capability, competency, correctness, accuracy, fitness for a particular
                        purpose, or quality of a Shop or its services and products. O'Reilly is independent of
                        and not affiliated in any way with the Shops. Listing in the O'Reilly Shop Referral program
                        simply means a Shop has fulfilled a certain volume of auto parts business with O'Reilly.
                        Furthermore, because a Shop is listed in the O'Reilly Shop Referral program does not represent
                        or convey any endorsement or recommendation by O'Reilly of the work, products or services
                        provided by the Shop. ACCORDINGLY, O'REILLY MAKES NO REPRESENTATION OR WARRANTY, EXPRESS
                        OR IMPLIED, CONCERNING ANY ADVICE, RECOMMENDATION, WORK, OR SERVICES PERFORMED BY SUCH SHOPS
                        AND EXPRESSLY DISCLAIMS THE SAME. FURTHER, O'REILLY ASSUMES NO AND EXPRESSLY DISCLAIMS ANY
                        LIABILITY AS TO THE SERVICES, PRODUCTS OR PARTS PROVIDED BY SUCH SHOPS UNLESS A PARTICULAR
                        PRODUCT OR PART WAS BOUGHT DIRECTLY BY YOU FROM AN O'REILLY STORE, IN WHICH CASE THE APPLICABLE
                        O'REILLY WARRANTY SHALL APPLY.
                    </p>
                    <button @click="$refs.modal.close()"
                        class="btn-green mx-1 w-32 rounded">
                        OK
                    </button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Modal from '@/js/components/Modal.vue';
import SvgOreillyLogoLg from 'svg/oreilly-logo-lg.svg';
import SvgOreillyLogoMd from 'svg/oreilly-logo-md.svg';

export default {
    components: {
        Modal,
        SvgOreillyLogoLg,
        SvgOreillyLogoMd
    },
    props: {
        headerIsFixed: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            headerTransparent: false,
            menuIsOpen: false,
            screenSize: {
                isSmall: false,
                specificSize: ''
            }
        };
    },
    methods: {
        handleScroll() {
            if (this.headerIsFixed) {
                this.headerTransparent = window.scrollY < 80;
            }
        },
        handleResize() {
            if (window.innerWidth <= 810) {
                this.screenSize.isSmall = true;
                if (window.innerWidth <= 400) {
                    this.screenSize.specificSize = 'xs';
                } else {
                    this.screenSize.specificSize = 'sm';
                }
            } else {
                this.screenSize.isSmall = false;
                this.screenSize.specificSize = 'lg';
            }
        },
        openMenu() {
            this.menuIsOpen = !this.menuIsOpen;
        }
    },
    mounted() {
        this.handleResize();
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('scroll', this.handleScroll);
    }
};
</script>
